import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function BeforeAfter() {
  return <section className="py-20 px-4 bg-gray-900 text-white" data-id="element-18">
      <div className="max-w-5xl mx-auto" data-id="element-19">
        <h2 className="text-4xl md:text-5xl font-black text-center mb-16" data-id="element-20">
          Antes vs Después
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-21">
          {/* ANTES */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-red-900/30 border border-red-500/30 p-8 rounded-3xl" data-id="element-22">
            <h3 className="text-2xl font-black text-red-400 mb-6 text-center uppercase tracking-wider" data-id="element-23">
              ANTES del Mega Kit ❌
            </h3>
            <ul className="space-y-4 text-lg font-medium text-gray-300" data-id="element-24">
              <li className="flex items-start gap-3" data-id="element-25">
                <span className="text-red-500" data-id="element-26">❌</span> Lectura con miedo y
                trabas
              </li>
              <li className="flex items-start gap-3" data-id="element-27">
                <span className="text-red-500" data-id="element-28">❌</span> Frustración (de tu hijo
                y tuya)
              </li>
              <li className="flex items-start gap-3" data-id="element-29">
                <span className="text-red-500" data-id="element-30">❌</span> Improvisación constante
              </li>
              <li className="flex items-start gap-3" data-id="element-31">
                <span className="text-red-500" data-id="element-32">❌</span> "No sé qué hacer hoy"
              </li>
              <li className="flex items-start gap-3" data-id="element-33">
                <span className="text-red-500" data-id="element-34">❌</span> PDFs sueltos que se
                pierden
              </li>
              <li className="flex items-start gap-3" data-id="element-35">
                <span className="text-red-500" data-id="element-36">❌</span> Sensación de atraso
              </li>
            </ul>
          </motion.div>

          {/* DESPUES */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-green-900/30 border-2 border-green-500 p-8 rounded-3xl relative overflow-hidden" data-id="element-37">
            <div className="absolute top-0 right-0 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-38">
              TU OBJETIVO
            </div>
            <h3 className="text-2xl font-black text-green-400 mb-6 text-center uppercase tracking-wider" data-id="element-39">
              DESPUÉS con el Mega Kit ✅
            </h3>
            <ul className="space-y-4 text-lg font-bold text-white" data-id="element-40">
              <li className="flex items-start gap-3" data-id="element-41">
                <span className="text-green-400" data-id="element-42">✅</span> Lectura más fluida y
                segura
              </li>
              <li className="flex items-start gap-3" data-id="element-43">
                <span className="text-green-400" data-id="element-44">✅</span> Más comprensión
                (explica lo que leyó)
              </li>
              <li className="flex items-start gap-3" data-id="element-45">
                <span className="text-green-400" data-id="element-46">✅</span> Rutina corta y
                sostenible (5–10 min)
              </li>
              <li className="flex items-start gap-3" data-id="element-47">
                <span className="text-green-400" data-id="element-48">✅</span> Actividades claras,
                sin adivinar
              </li>
              <li className="flex items-start gap-3" data-id="element-49">
                <span className="text-green-400" data-id="element-50">✅</span> Material ordenado y
                listo
              </li>
              <li className="flex items-start gap-3" data-id="element-51">
                <span className="text-green-400" data-id="element-52">✅</span> Más confianza y
                tranquilidad
              </li>
            </ul>
          </motion.div>
        </div>

        <div className="flex justify-center" data-id="element-53">
          <CTAButton text="¡QUIERO VER A MI HIJO LEER CON CONFIANZA!" className="max-w-2xl" data-id="element-54" />
        </div>
      </div>
    </section>;
}